'use strict'

class SwatchPage {
    constructor(_obj) {
        this.number_of_colors = _obj.number_of_colors
        this.page_name = _obj.page_name
        this.page_number = _obj.page_number
        this.swatch_id = _obj.swatch_id
    }
}

export default SwatchPage
